import React from 'react';
import { Link } from 'react-router-dom';
import PageBanner from '../components/PageBanner';
import Meta from "../components/Meta";
import ThankYouContent from '../components/ThankYouContent';
const ThankYou = () => {
    return (
        <>
        <Meta title="Book Now - THE CUTTING BAR" />
        <PageBanner imageUrl="assets/images/background/6.jpg" heading="THANK YOU" />
        <ThankYouContent />
        </>
  );
};

export default ThankYou;
